import React from "react";
import { Body, Label } from "../../../../components/Typography";
import { formatCurrency } from "../../../../utils/misc.util";
import { OrderDetailCard, CardSection } from "./OrderDetailCard";
import { PaymentLink } from "./PaymentLink";
import { formatOrderDate, getMostRecentRefund, type Order, type OrderRefund } from "./shared";

export const RefundCard: React.FC<{ order: Order }> = ({ order }) => {
  const refunds = order.refunds ?? [];
  if (refunds.length === 0) return null;

  const mostRecentRefund = getMostRecentRefund(refunds);
  const totalRefunded = sumRefundAmounts(refunds);
  const currency = order.pricing?.currency ?? null;

  return (
    <OrderDetailCard>
      <CardSection>
        <Label>Refund</Label>
        <Body>
          {formatCurrency(currency, totalRefunded)} refunded
          {mostRecentRefund?.createdAt && <> on {formatOrderDate(mostRecentRefund.createdAt)}</>}
          {mostRecentRefund?.id != null && <PaymentLink paymentId={mostRecentRefund.id} />}
        </Body>
      </CardSection>
    </OrderDetailCard>
  );
};

function sumRefundAmounts(refunds: readonly OrderRefund[]): number {
  return refunds.reduce((sum, refund) => sum + (refund.amount ?? 0), 0);
}
